import { render, staticRenderFns } from "./MulheresPerfumadas.vue?vue&type=template&id=21a2a0a7&scoped=true"
import script from "./MulheresPerfumadas.vue?vue&type=script&lang=js"
export * from "./MulheresPerfumadas.vue?vue&type=script&lang=js"
import style0 from "./MulheresPerfumadas.vue?vue&type=style&index=0&id=21a2a0a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a2a0a7",
  null
  
)

export default component.exports